import React from 'react';
import { InView } from 'react-intersection-observer';

import { TextButton } from '@components/Button/variants';
import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';
import IconArrow from '@components/Images/IconArrow';
import { THREAD_INPUT_PLACEHOLDER } from '@components/pages/AI/DeepResearch/Form/constants';
import DeepResearchSuggested from '@components/pages/AI/DeepResearch/Suggested';
import { SUGGESTED_PROMPT_QUERY_PARAM } from '@components/pages/AI/DeepResearch/constants';
import useEventTracking from '@hooks/useEventTracking';
import { deep_research_path } from '@routes';
import { ClickTarget, TrackingLocation, click, impression } from '@tracking';

import MyTISection from './Section';
import { MY_TI_SECTION_IDS } from './constants';
import useRegisterSection from './useRegisterSection';

const MyTIDeepResearch = () => {
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.DeepResearchMyTI,
  });
  useRegisterSection(MY_TI_SECTION_IDS.DeepResearch);

  const handleSuggestedPromptClick = (prompt) => {
    trackEvent(click({ clickTarget: ClickTarget.SuggestedPrompt, clickText: prompt }));
    const anchor = document.createElement('a');
    anchor.href = deep_research_path({ [SUGGESTED_PROMPT_QUERY_PARAM]: prompt });
    anchor.click();
  };

  return (
    <Track>
      <MyTISection id={MY_TI_SECTION_IDS.DeepResearch}>
        <InView
          onChange={(inView) => {
            inView && trackEvent(impression({ impressionElement: MY_TI_SECTION_IDS.DeepResearch }));
          }}
          triggerOnce
        >
          <div className="flex flex-col gap-8">
            <header>
              <IconDeepResearchText className="block" width={335} aria-label="Deep Research logo" />
              <p className="mb-0 mt-8 font-suisse-neue text-subheadline-sm">
                I am trained on The Information’s extensive reporting. Try asking me to…
              </p>
            </header>
            <DeepResearchSuggested
              disablePrompts={false}
              setSuggestedPrompt={(prompt) => handleSuggestedPromptClick(prompt)}
            />
            <TextButton as="link" className="group mt-28" href={deep_research_path()}>
              {THREAD_INPUT_PLACEHOLDER}
              <IconArrow
                className="ml-8 rotate-180 text-primary-magenta transition-transform duration-200 group-hover:translate-x-4"
                width={16}
              />
            </TextButton>
          </div>
        </InView>
      </MyTISection>
    </Track>
  );
};

export default MyTIDeepResearch;
